import React from 'react';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from 'reactstrap';

class Help extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="8">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Need Help?</h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div>
                    If you have any questions or issues, please <b>first</b>{' '}
                    check our{' '}
                    <a href="https://docs.snailbot.io" target="_blank">
                      documentation
                    </a>{' '}
                    carefully (the password is <i>snailgang</i>). We put a lot
                    of effort into it so please give it an honest read.
                  </div>
                  <br />

                  <div>
                    If you still want help, make sure you're in the{' '}
                    {this.props.getDiscordInviteLink()} and create a support
                    ticket using the <b>#create-a-ticket</b> channel. We're
                    happy to answer any of your questions.
                  </div>
                  <br />

                  <div>
                    If you're having issues opening a Discord support ticket,
                    email us at <b>support@snailbot.io</b> from the email you
                    purchased SnailBot with.
                  </div>
                  <br />

                  <div>Thank you.</div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Help;
